import { $ } from "../../../../helpers/dom-selectors.js";
export default function makeAddInstrument({ addBtns, forms }) {
    _init();
    return Object.freeze({
        addListener
    });
    function _init() {
        addBtns.forEach(btn => addListener(btn));
        forms.forEach(form => {
            const deleteBtns = $(form, '.delete-input-btn');
            deleteBtns.shift();
            deleteBtns.forEach(btn => _addDeleteBtn(btn));
        });
    }
    function addListener(btn) {
        btn.addEventListener('click', e => _add(btn));
    }
    function _add(btn) {
        const target = btn.previousElementSibling;
        if (!target)
            return;
        const cloned = target.cloneNode(true);
        const deleteBtn = $(cloned, '.delete-input-btn')[0];
        _addDeleteBtn(deleteBtn);
        _reset(cloned);
        target.after(cloned);
    }
    function _reset(el) {
        const inputs = $(el, '.input-fields');
        inputs.forEach(input => {
            input.value = '';
            input.removeAttribute('value');
            input.innerHTML = '';
        });
    }
    function _addDeleteBtn(btn) {
        btn.classList.remove('no-display');
        btn.addEventListener('click', e => _delete(btn));
    }
    function _delete(btn) {
        const parent = btn.parentElement;
        if (!parent)
            return;
        parent.remove();
    }
}
